<div class="action-item"
     fxLayout="row"
     fxLayoutAlign="space-between center"
     [ngClass]="{'active': active}"
     (click)="onRedirectToLink()">
  {{ title }}
  <i class="material-icons" [innerHTML]='linkIsExternal ? "launch" : "chevron_right"'></i>
</div>
